<template>
  <div>
    <ul class="BottomMenu">
      <div class="bottom-item" tag="li" @click="userCheck('AppOrderHistory')" >
        <div class="bottom-box">
          <img src="@/assets/img/ic-toolbar-order-list.png" alt="">
          <span class="txt">{{$t(`BottomMenu.orderHistory`)}}</span>
        </div>
      </div>
      <div class="bottom-item" tag="li" @click="userCheck('AppOrderStore')" >
        <div class="bottom-box">
          <img src="@/assets/img/ic-toolbar-order-store.png" alt="">
          <span class="txt">{{$t(`BottomMenu.orderStore`)}}</span>
        </div>
      </div>
      <div class="bottom-item" tag="li" @click="userCheck('AppQrScan')" >
        <li class="bottom-item">
          <div class="bottom-box">
            <img src="@/assets/img/ic_qr.png" alt="">
            <span class="qr-img"><img src="@/assets/img/1268.png" alt=""></span>
            <span class="txt">{{$t(`BottomMenu.qrScan`)}}</span>
          </div>
        </li>
      </div>
      <div class="bottom-item" tag="li" @click="userCheck('AppCart')" >
        <div class="bottom-box">
          <img src="@/assets/img/ic-toolbar-cart.png" alt="">
          <span class="txt">{{$t(`BottomMenu.cart`)}}</span>
        </div>
      </div>
      <div class="bottom-item" tag="li" @click="userCheck('AppMyPage')" >
        <div class="bottom-box">
          <img src="@/assets/img/ic-toolbar-mypage.png" alt="">
          <span class="txt">{{$t(`BottomMenu.myPage`)}}</span>
        </div>
      </div>
    </ul>
    <DoubleBtnDialog
      v-if='showDoubleBtnDialogFlag'
      :message='doubleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'
      :onClickCancelBtn='onClickCancelBtn'
      :imgFlag='false'
    />
  </div>
</template>

<script>
import DoubleBtnDialog from '@/components/Dialog/DoubleBtnDialog.vue'
import { MESSAGE_DOUBLE_BUTTON } from '@/utils/Message'
import { CHANGE_LOGIN_AUTH_FLAG, SET_DIRECTFLAG } from '@/store/_actions/actionTypes'
export default {
  components: {
    DoubleBtnDialog
  },
  data () {
    return {
      showDoubleBtnDialogFlag: false,
      onClickConfirmBtn: undefined,
      onClickCancelBtn: undefined
    }
  },
  methods: {
    userCheck (path) {
      this.$store.dispatch(CHANGE_LOGIN_AUTH_FLAG, false)
      this.$store.dispatch(SET_DIRECTFLAG, false)
      if (!this.isUser && !(path == 'AppQrScan' || path == 'AppCart')) {
        // 하단 마이페이지
        const alertMsg = MESSAGE_DOUBLE_BUTTON[7]
        this.showDoubleBtnDialog(alertMsg, () => {
          localStorage.setItem('joinFlag', true)
          this.$router.push({ name: 'AppOrderSelect' })
          this.hideDoubleBtnDialog()
        })
      } else {
        if (path == 'AppMyPage') {
          sessionStorage.setItem('backUrl', window.location.href)
        }
        this.$router.push({ name: path })
      }
    },
    showDoubleBtnDialog (message, confirmBtn) { // double btn show
      this.doubleBtnMsgType = message
      this.onClickConfirmBtn = confirmBtn
      this.onClickCancelBtn = this.hideDoubleBtnDialog
      this.showDoubleBtnDialogFlag = true
    },
    hideDoubleBtnDialog () {
      this.showDoubleBtnDialogFlag = false
    }
  }
}
</script>

<style scoped>
</style>
